<template>
  <v-app>
    <v-container fluid>
      <v-card elevation="2" outlined>
        <v-card-title>
          <!--                                    v-if="$can('transaction_create')"-->
          <v-btn
            to="/departments/create"
            rounded
            color="#308BB0"
            class="text-white"
          >
            <v-icon>mdi-plus</v-icon>
            افزودن دپارتمان
          </v-btn>
          <!--                    <v-spacer/>-->
          <!--                    {{$route.meta.title}}-->
          <!--                    <v-spacer/>-->
          <!--                    <v-btn :loading="loading" @click="this.reloadTable" color="primary" rounded-->
          <!--                           class="text-white">-->
          <!--                        <v-icon>mdi-refresh</v-icon>-->
          <!--                        به روزرسانی-->
          <!--                    </v-btn>-->
        </v-card-title>
        <v-divider />

        <div class="row">
          <div class="col-md-12 p-5">
            <data-table
              orderDir="desc"
              :data="data"
              :columns="columns"
              :debounce-delay="5000"
              :translate="translate"
              :per-page="[10, 25, 50, 100, 200, 400]"
              @on-table-props-changed="reloadTable"
            >
            </data-table>
          </div>
        </div>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import { SET_BREADCRUMB } from "../../../../core/services/store/breadcrumbs.module";
import PaymentBtn from "./PaymentBtn";
import Button from "@/view/pages/Button";

export default {
  data() {
    return {
      columns: [
        {
          label: "شناسه",
          name: "id",
          orderable: true,
        },
        {
          label: "نام",
          name: "title",
          orderable: true,
          searchable: true,
        },
        // {
        //     label: 'درایور',
        //     name: 'driver',
        //     orderable: true,
        //     searchable: true,
        // },
        //
        // {
        //     label: 'نوع',
        //     name: 'type',
        //     orderable: true,
        //     searchable: true,
        //     transform: (value) => {
        //       return value.data.type ===  'regular' ? "<span class='badge-pill badge-primary'>حقیقی </span>":'<v-chip>حقوقی </v-chip>';
        //     }
        // },
        {
          name: "actions",
          label: "عملیات",
          component: Button,
          handler: this.actions,
          event: "action",
          meta: {
            permission_prefix: "department_",
            buttons: [
              {
                name: "delete",
                label: "حذف",
                icon: "trash",
                class: "btn-delete",
              },
            ],
          },
        },
      ],
      url: "department",
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      data: {},
      loading: false,
    };
  },

  created() {
    this.getAllPaymentGateways(this.url);
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },

  methods: {
    getAllPaymentGateways(url = this.url, query = this.tableProps) {
      this.requestApiGet(url, query).then((response) => {
        this.data = response.data;
        this.loading = false;
      });
    },

    delete(data) {
      let id = data.id;
      this.$swal({
        title: "حذف",
        text: "آیا از حذف این دپارتمان اطمینان دارید؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "بله",
        cancelButtonText: "خیر",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.requestApiDelete(this.url + "/" + id)
            .then((response) => {
              this.getAllPaymentGateways(this.url);
            })
            .catch((error) => {});
        }
      });
    },

    reloadTable(tableProps) {
      this.loading = true;
      this.getAllPaymentGateways(this.url, tableProps);
    },

    actions(data, type) {
      this[type](data);
    },

    edit(data) {
      this.$router.push({
        name: "payment.edit",
        params: { id: data.id },
      });
    },
  },
};
</script>
